import React, { useContext, useEffect, useState } from 'react'
import { StageDiveConfig, StageDiveConfigContext } from 'util/app_initialization/appconfig'
import { useTranslation } from 'react-i18next'
import { MainContainer, CardContainer, StyledCard, ContentContainer } from '../focus_view_shared.styles'
import { AlertContainer, StyledAlert } from './manage_access_requests.styles'
import { CardHeader } from '@amzn/storm-ui'
import { Text } from '@amzn/storm-ui'
import { LinkAdvertisersV2 } from './link_advertisers_v2'
import * as i18nKeyList from './manage_access_requests_i18n_mappings'
import { toNullable } from 'fp-ts/es6/Option'
import { useLoginContext } from 'stagedive/LoginContext'
import { getManageAccountsURL } from '../ads_console_utils'
import * as AACChromeAPI from '@amzn/aac-chrome-api'
import { getMetricsPublisherChainAsync } from '@amzn/aapn-front-end-metrics'

export const ManageAccessRequests: React.FunctionComponent = (): JSX.Element => {
  const stageDiveConfig = useContext<StageDiveConfig>(StageDiveConfigContext)
  const { t } = useTranslation()
  const [showSuccessAlert, setShowSuccessAlert] = useState<boolean>(false)
  const { loginContext } = useLoginContext()
  const partnerAccountId = toNullable(loginContext.partnerProfileId) ?? ''

  useEffect(() => {
    getMetricsPublisherChainAsync('AdsConsoleInt').then((p) => p.publishCounter('view', 1).publishString(`page`, `manage-access-request`))
  }, [])

  /* istanbul ignore next */
  useEffect(() => {
    const config = AACChromeAPI.getChromeConfiguration()
    const pageHeader = new AACChromeAPI.PageHeader()
    const objectInfo = new AACChromeAPI.ObjectInfo()
    const actionList = new AACChromeAPI.ItemList()

    config.setPageLayoutType('FOCUS')
    const focusModeExitEventId = 'ExitFocusView'

    const backToAccountsLink = new AACChromeAPI.Button()
    const backToAccountsLinkButtonId = 'backToAccountsLink'
    backToAccountsLink.setId(backToAccountsLinkButtonId)
    backToAccountsLink.setLabel(t(i18nKeyList.MANAGE_ACCESS_REQUESTS_BACK_TO_ACCOUNTS))
    backToAccountsLink.setButtonType(AACChromeAPI.ButtonType.LINK)

    const backToAccountsLinkFn = (): void => {
      window.location.href = getManageAccountsURL(partnerAccountId, stageDiveConfig.hostname)
    }
    AACChromeAPI.getActionEventTarget().addEventListener(backToAccountsLinkButtonId, backToAccountsLinkFn)
    AACChromeAPI.getCommonEventTarget().addEventListener(focusModeExitEventId, backToAccountsLinkFn)

    actionList.addItem(backToAccountsLink)

    objectInfo.setActions(actionList)

    pageHeader.setObjectInfo(objectInfo)
    pageHeader.setPageName(t(i18nKeyList.MANAGE_ACCESS_REQUESTS_PAGE_TITLE))
    config.setPageHeader(pageHeader)
    AACChromeAPI.setChromeConfiguration(config)
    return () => {
      AACChromeAPI.getActionEventTarget().removeEventListener(backToAccountsLinkButtonId, backToAccountsLinkFn)
      AACChromeAPI.getCommonEventTarget().removeEventListener(focusModeExitEventId, backToAccountsLinkFn)
    }
  }, [t])

  return (
    <MainContainer>
      <ContentContainer>
        <AlertContainer>
          <StyledAlert type={'success'} isOpen={showSuccessAlert} withCloseButton={true} onClose={() => setShowSuccessAlert(false)}>
            <Text>{t(i18nKeyList.MANAGER_ACCESS_REQUESTS_WITHDRAW_SUCCESS_ALERT)}</Text>
          </StyledAlert>
        </AlertContainer>
        <CardContainer>
          <StyledCard>
            <CardHeader>
              <Text type="h2">{t(i18nKeyList.MANAGER_ACCESS_REQUESTS_CARD_HEADER)}</Text>
            </CardHeader>
            <LinkAdvertisersV2 setSuccessAlert={setShowSuccessAlert} />
          </StyledCard>
        </CardContainer>
      </ContentContainer>
    </MainContainer>
  )
}
